export default __webpack_public_path__ + "f402ec83b06fc0692bb2be42b6361d6a.png";